<esp-deposit-free-text [autoPopulated]="isAutoPopulated"
                       [freeText]="depositFormDataService.methods"
                       placeholder="{{'research.methods.text' | customTranslate}}">
</esp-deposit-free-text>
